<template>
  <div
    class="stamp-container"
    v-show="type != null"
    :style="{
      opacity: confidenceOpacity,
      transform: 'scale(' + scale + ')',
      'background-color': showBackground ? '#20303d88' : null
    }"
  >
    <div class="stamp-wrapper">
      <div
        class="stamp dislike"
        :class="{ dark: showBackground, light: !showBackground }"
        v-show="type === MatchType.Dislike"
      >
        {{ $t("components.candidate.candidate_card.swipe_reject") }}
      </div>
      <div
        class="stamp love"
        :class="{ dark: showBackground, light: !showBackground }"
        v-show="type === MatchType.Love"
      >
        {{ $t("components.candidate.candidate_card.swipe_love") }}
      </div>
      <div
        class="stamp like"
        :class="{ dark: showBackground, light: !showBackground }"
        v-show="type === MatchType.Like"
      >
        {{ $t("components.candidate.candidate_card.swipe_accept") }}
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { MatchType } from "@/utils/MatchType";

export default {
  name: "MatchStamps",
  props: {
    matchBus: {
      type: Vue,
      required: true
    },
    showBackground: {
      type: Boolean,
      default: true
    }
  },
  data: () => {
    return {
      MatchType: MatchType,
      type: null,
      animationId: null,
      confidenceOpacity: 0,
      scale: 1
    };
  },
  created() {
    this.matchBus.$on("match", this.onMatch);
    this.matchBus.$on("drag", this.onDrag);
    this.matchBus.$on("dragend", this.onDragEnd);
  },
  destroyed() {
    this.matchBus.$off("match", this.onMatch);
    this.matchBus.$off("drag", this.onDrag);
    this.matchBus.$off("dragend", this.onDragEnd);
  },
  methods: {
    onMatch(type) {
      if (this.animationId != null) {
        this.type = null;
        this.animationId = null;
        this.confidenceOpacity = 0;
        setTimeout(() => {
          this.onMatch(type);
        }, 5);
        return;
      }
      const animationId = this.$uuid.v4();
      this.type = type;
      this.animationId = animationId;
      this.confidenceOpacity = 0;
      this.scale = 2;
      setTimeout(() => {
        this.confidenceOpacity = 1;
        this.scale = 1;
      }, 50);
      setTimeout(() => {
        if (this.animationId !== animationId) {
          return;
        }
        this.confidenceOpacity = 0;
        this.animationId = animationId;
      }, 1000);
    },
    onDrag(event) {
      const type = event.type;
      this.type = type;
      this.confidenceOpacity = Math.min(
        1,
        Math.max(0, event.confidence - 0.02) *
          (type === MatchType.Love ? 10 : 8)
      );
    },
    onDragEnd() {
      this.confidenceOpacity = 0;
    }
  }
};
</script>

<style scoped lang="scss">
.stamp-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  border-radius: 2rem;
  pointer-events: none;
  transition: opacity 0.05s ease-out, transform 0.05s ease-out;
}

.stamp-wrapper {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
}

.stamp.dark {
  box-shadow: rgba(20, 20, 40, 0.9) 0 0 2em;
  background-color: rgba(20, 20, 40, 0.6);
  text-shadow: rgba(20, 20, 40, 1) 0 0 0.3em;
}

.stamp.light {
  box-shadow: rgba(0, 0, 0, 0.2) 0 0 2em, inset rgba(0, 0, 0, 0.2) 0 0 0.5em;
  background-color: rgba(255, 255, 255, 0.5);
  text-shadow: white 0 0 0.3em;
}

.stamp {
  width: 100%;
  border-radius: 1rem;
  border-width: 0.65rem;
  text-transform: uppercase;
  font-size: 4.5rem;
  font-weight: bold;
  &.dislike {
    width: 130%;
    margin-left: -15%;
    transform: rotate(50deg);
    color: #f96046;
    border-color: #f96046;
  }

  &.love {
    color: #ff4498;
    border-color: #ff4498;
    font-size: 10vw;
  }

  &.like {
    width: 130%;
    margin-left: -15%;
    transform: rotate(-50deg);
    color: #00ef8e;
    border-color: #00ef8e;
  }
}
@media screen and (min-width: 768px) {
  .stamp.love {
    font-size: 4.5rem !important;
  }
}
</style>
